export function sanitizeFoodOrders(orders) {
  return (Array.isArray(orders) ? orders : [])
    .map((o) => {
      const food = String(o?.food || "").trim();
      const quantity = Number(o?.quantity || 0);
      const total = Number(o?.total || 0);
      return {
        food,
        quantity: Number.isFinite(quantity) ? quantity : 0,
        total: Number.isFinite(total) ? total : 0,
      };
    })
    .filter((o) => o.food && o.quantity > 0);
}

// One submission remains one order, even when appended to a customer's daily transaction.
export function createFoodOrderBatch(orders, orderId, orderedAt) {
  return sanitizeFoodOrders(orders).map((line) => ({
    ...line,
    orderId,
    orderedAt: orderedAt.toISOString(),
  }));
}

export function upsertFoodOrderLine(orders, foodItem, deltaQuantity = 1) {
  const name = String(foodItem?.name || "").trim();
  const price = Number(foodItem?.price || 0);
  if (!name || !Number.isFinite(price)) return Array.isArray(orders) ? orders : [];

  const next = (Array.isArray(orders) ? orders : []).map((o) => ({ ...o }));

  const existingIndex = next.findIndex((o) => o.food === name);
  if (existingIndex !== -1) {
    const quantity = Math.max(
      1,
      Number(next[existingIndex].quantity || 0) + Number(deltaQuantity || 0)
    );
    next[existingIndex] = { food: name, quantity, total: price * quantity };
    return next;
  }

  const emptyIndex = next.findIndex((o) => !String(o.food || "").trim());
  if (emptyIndex !== -1) {
    const quantity = Math.max(1, Number(next[emptyIndex].quantity || 1));
    next[emptyIndex] = { food: name, quantity, total: price * quantity };
    return next;
  }

  const initialQuantity = Math.max(1, Number(deltaQuantity || 1));
  return [...next, { food: name, quantity: initialQuantity, total: price * initialQuantity }];
}
